import { useMemo } from "react";

import { WELCOME_MESSAGES_SHOWN_PREFERENCE_KEY } from "@/hooks/use-onboarding-completion";
import { usePreferenceValue } from "@/hooks/use-preference-value";
import { useOrganization } from "@/queries/organization-queries";
import { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";

export function useIsWelcomeEligible(): boolean {
    const { data: organization } = useOrganization();
    const { value: welcomeMessagesShown } = usePreferenceValue(WELCOME_MESSAGES_SHOWN_PREFERENCE_KEY);

    return useMemo(() => {
        if (!organization) return false;
        if (welcomeMessagesShown !== "false") return false;
        const tier = organization.tier;
        return tier === OrganizationTier.FREE_ONA || tier === OrganizationTier.CORE;
    }, [organization, welcomeMessagesShown]);
}
